<div
    *ngIf="type !== basicInputTypeEnum.NUMBER; else numbers"
    class="input-group {{ classes }}"
    [ngClass]="{ 'input-icon': icons, 'has-trailing-sign': trailingSign }"
>
    <span class="icon {{ icons }}"></span>
    <input
        appInputTrimmer
        [type]="type"
        class="basic-input"
        [name]="inputId"
        [id]="inputId"
        [value]="value"
        (input)="onInput()"
        (blur)="onBlur()"
        [placeholder]="placeholder | translate"
        [formControl]="inputControl"
        [readOnly]="readOnly || disabled"
        [maxLength]="maxLength"
        [ngClass]="{ 'invalid-control': !isValid && touched && !disabled, 'read-only': readOnly || disabled }"
        [textMask]="maskConfig"
        [pattern]="pattern"
        (keydown.enter)="onEnter($event)"
    />
    <span *ngIf="trailingSign" class="trailing-sign">{{ trailingSign }}</span>
</div>
<ng-template #numbers>
    <div class="input-group {{ classes }}" [ngClass]="{ 'input-icon': icons, 'has-trailing-sign': trailingSign }">
        <span class="icon {{ icons }}"></span>
        <input
            [formControl]="inputControl"
            [type]="basicInputTypeEnum.TEXT"
            class="basic-input"
            [name]="inputId"
            [id]="inputId"
            (input)="onInputNumber()"
            (blur)="onBlur()"
            [placeholder]="placeholder | translate"
            [readOnly]="readOnly || disabled"
            [maxLength]="maxLength"
            [ngClass]="{ 'invalid-control': !isValid && touched && !disabled, 'read-only': readOnly || disabled }"
            [textMask]="maskConfig"
        />
        <span *ngIf="trailingSign" class="trailing-sign">{{ trailingSign }}</span>
    </div>
</ng-template>
<div class="errors">
    <ng-content></ng-content>
</div>
